// extracted by mini-css-extract-plugin
var _1 = "InvoicesPageMobileFooter_actions__6BFY9";
var _2 = "InvoicesPageMobileFooter_footerDivider__Usqhp";
var _3 = "InvoicesPageMobileFooter_mobileButtonsContainer__LSdIB";
export { _1 as "actions", _2 as "footerDivider", _3 as "mobileButtonsContainer" }
